import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHighlights: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHighlights"><Path d="M3.99927 6C3.32674 6.89535 2.80101 7.90726 2.4578 9H12V10.5H2.11175C2.03815 10.9893 2 11.4902 2 12C2 12.5098 2.03815 13.0107 2.11175 13.5H12V15H2.4578C2.80101 16.0927 3.32674 17.1046 3.99927 18H12V19.5H5.38544C7.14827 21.0559 9.46388 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C9.46388 2 7.14827 2.94409 5.38544 4.5H12V6H3.99927Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHighlights;
